import Servicios from "../../Components/Servicios/Servicios";
import { serviciosWeb } from "../../Data/serviciosWeb";


function DesarrolloWeb() {
  return (
    <>
    <div className="desarrolloWeb">
      <Servicios
        etiqueta="SOLUCIONES DIGITALES"
        titulo="Elegí el nivel de desarrollo web"
        subtitulo="No se trata solamente de tener una página web. Creamos un sistema que te ayuda a conseguir, organizar y gestionar clientes."
        servicios={serviciosWeb}
        background="#07111f"
         colorh2 = "#f5f1f1"
        colorp = "#c5c5c5"
      />
</div>
    </>
  );
}

export default DesarrolloWeb;


